
// 操作器
import { useNavigate, useLocation } from 'react-router-dom'
import React, { useState, useEffect, useRef } from 'react'
import { Card, theme, Form, InputNumber, App, message } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import dayjs from 'dayjs';
import { getAddress, connect, subscribe, publish, disconnect } from './operator_mqttService.js';
import { controlOperatorAPI } from '@/server/commandFlight.js'

import panel from "@/common/img/command_flight/operator/panel.svg" // 操作器
import half from "@/common/img/command_flight/operator/half.svg" // 点击后操作器
import uplift from "@/common/img/command_flight/operator/uplift.svg" // 抬升
import decline from "@/common/img/command_flight/operator/decline.svg" // 下降
import counterclockwise from "@/common/img/command_flight/operator/counterclockwise.svg" // 逆时针旋转
import clockwise from "@/common/img/command_flight/operator/clockwise.svg" // 顺时针旋转
import stop from "@/common/img/command_flight/operator/stop.svg" // 顺时针旋转


function Operator ({ isStart = null, dockId, sn }) {
  const navigate = useNavigate();//路由跳转
  const location = useLocation();//路由接受参数
  const token = localStorage.getItem('dock_token');
  const { token: { colorBgContainer, colorText }, } = theme.useToken(); //获取主题颜色

  const { message, modal } = App.useApp();
  const [loading, setLoading] = useState(false)//加载中···

  const mqttTimerRef = useRef(null)

  const [operateMsg, setOperateMsg] = useState('无操作')
  const [operateForm, setOperateForm] = useState({//操作表单信息
    flightSpeed: 1,//飞行速度
    liftingSpeed: 1,//升降速度
  })

  const flightSpeedRef = useRef(1)//飞行速度
  const liftingSpeedRef = useRef(1)//升降速度


  const [operateOpacity, setOperateOpacity] = useState({//操作器按钮的显示隐藏
    topOpacity: 0,//  ↑
    rightOpacity: 0,//  →
    bottomOpacity: 0,// ↓
    leftOpacity: 0,// ←
    upliftOpacity: 0,//抬升
    declineOpacity: 0,//下降
    counterclockwiseOpacity: 0,//逆时针旋转
    clockwiseOpacity: 0,//顺时针旋转
    stop: 0,//停止
  })
  const [mqttLink, setMqttLink] = useState(false)
  const mqttLinkRef = useRef(false)

  const openOrCloseMqttInfo = async (state) => { //开启或关闭mqtt链接
    let obj = {
      access_token: token,
      dock_id: dockId,
      type: state ? 'enter' : 'exit',
    }
    let res = await controlOperatorAPI(obj)

    if (res.ret !== 200) { message.warning(res.msg); return }
    getMqtt(res.data)

  }

  const getMqtt = (data) => {//获取mqtt连接
    getAddress(data)

    const onConnect = () => {
      subscribe(`thing/product/${sn}/drc/down`, 1);
      setMqttLink(true)
      mqttLinkRef.current = true
      let a = 0
      mqttTimerRef.current = setInterval(() => {//发送心跳包
        let body = {
          method: 'heart_beat',
          data: {
            ts: dayjs().valueOf(),
            seq: a += 1
          }
        }
        publish(`thing/product/${sn}/drc/down`, JSON.stringify(body), 0, false)
      }, 1000);
    };

    const onMessage = (topic, payload) => {
      // console.log('获取到的信息', topic, JSON.parse(payload));
    };

    const onError = (error) => {
      console.error('MQTT error:', error);
    };

    connect(onConnect, onMessage, onError);
  }


  const mouseClickRef = useRef(null)//鼠标点击的计时事件
  const mouseClickStart = (body) => {//鼠标开始点击
    if (mqttLinkRef.current && !hasKeyboardPerator.current) {
      hasMousePerator.current = true
      let num = 0
      mouseClickRef.current = setInterval(() => {
        body.data = { ...body.data, seq: num, }
        num += 1
        publish(`thing/product/${sn}/drc/down`, JSON.stringify(body), 0, false)
      }, 100);
    }
  }

  const mouseClickEnd = () => {//鼠标结束点击
    if (mouseClickRef.current) {
      hasMousePerator.current = false
      clearInterval(mouseClickRef.current)
      mouseClickRef.current = null
      setOperateMsg('无操作')
    }
  }

  const W_pressDownRef = useRef(false)//监听 W 是否按下
  const S_pressDownRef = useRef(false)//监听 S 是否按下
  const A_pressDownRef = useRef(false)//监听 A 是否按下
  const D_pressDownRef = useRef(false)//监听 D 是否按下
  const E_pressDownRef = useRef(false)//监听 E 是否按下
  const Q_pressDownRef = useRef(false)//监听 Q 是否按下
  const UP_pressDownRef = useRef(false)//监听 ↑ 是否按下
  const Down_pressDownRef = useRef(false)//监听 ↓ 是否按下

  const hasMousePerator = useRef(false)//是否鼠标在操作
  const hasKeyboardPerator = useRef(false)//是否键盘在操作

  let num = -1
  const handleKeyDown = (event) => {  //监听 键盘按下事件
    if (!mqttLinkRef.current || hasMousePerator.current) { return }
    hasKeyboardPerator.current = true
    let opeFmMsg = '无操作'
    let ope = operateOpacity
    if ((event.key === 'w' || event.key === 'W') && !S_pressDownRef.current && !A_pressDownRef.current && !D_pressDownRef.current && !E_pressDownRef.current && !Q_pressDownRef.current && !UP_pressDownRef.current && !Down_pressDownRef.current) {//前进
      W_pressDownRef.current = true
      num += 1
      opeFmMsg = '前进'
      ope.topOpacity = 1
    }
    if ((event.key === 's' || event.key === 'S') && !W_pressDownRef.current && !A_pressDownRef.current && !D_pressDownRef.current && !E_pressDownRef.current && !Q_pressDownRef.current && !UP_pressDownRef.current && !Down_pressDownRef.current) {//后退
      S_pressDownRef.current = true
      num += 1
      opeFmMsg = '后退'
      ope.bottomOpacity = 1
    }
    if ((event.key === 'a' || event.key === 'A') && !W_pressDownRef.current && !S_pressDownRef.current && !D_pressDownRef.current && !E_pressDownRef.current && !Q_pressDownRef.current && !UP_pressDownRef.current && !Down_pressDownRef.current) {//左移
      A_pressDownRef.current = true
      num += 1
      opeFmMsg = '向左平移'
      ope.leftOpacity = 1
    }
    if ((event.key === 'd' || event.key === 'D') && !W_pressDownRef.current && !S_pressDownRef.current && !A_pressDownRef.current && !E_pressDownRef.current && !Q_pressDownRef.current && !UP_pressDownRef.current && !Down_pressDownRef.current) {//右移
      D_pressDownRef.current = true
      num += 1
      opeFmMsg = '向右平移'
      ope.rightOpacity = 1
    }
    if ((event.key === 'e' || event.key === 'E') && !W_pressDownRef.current && !S_pressDownRef.current && !A_pressDownRef.current && !D_pressDownRef.current && !Q_pressDownRef.current && !UP_pressDownRef.current && !Down_pressDownRef.current) {//顺时针旋转
      E_pressDownRef.current = true
      num += 1
      opeFmMsg = '顺时针旋转'
      ope.clockwiseOpacity = 1
    }
    if ((event.key === 'q' || event.key === 'Q') && !W_pressDownRef.current && !S_pressDownRef.current && !A_pressDownRef.current && !D_pressDownRef.current && !E_pressDownRef.current && !UP_pressDownRef.current && !Down_pressDownRef.current) {//逆时针旋转
      Q_pressDownRef.current = true
      num += 1
      opeFmMsg = '逆时针旋转'
      ope.counterclockwiseOpacity = 1
    }

    if (event.key === 'ArrowUp' && !W_pressDownRef.current && !S_pressDownRef.current && !A_pressDownRef.current && !D_pressDownRef.current && !E_pressDownRef.current && !Down_pressDownRef.current) {//UP
      UP_pressDownRef.current = true
      num += 1
      opeFmMsg = '抬升'
      ope.upliftOpacity = 1
    }

    if (event.key === 'ArrowDown' && !W_pressDownRef.current && !S_pressDownRef.current && !A_pressDownRef.current && !D_pressDownRef.current && !E_pressDownRef.current && !UP_pressDownRef.current) {//down
      Down_pressDownRef.current = true
      num += 1
      opeFmMsg = '下降'
      ope.declineOpacity = 1
    }

    let body = {
      method: 'drone_control',
      data: { seq: num }
    }

    switch (true) {
      case W_pressDownRef.current:
        body.data = { x: flightSpeedRef.current, ...body.data, }
        break;
      case S_pressDownRef.current:
        body.data = { x: -flightSpeedRef.current, ...body.data, }
        break;
      case A_pressDownRef.current:
        body.data = { y: -flightSpeedRef.current, ...body.data, }
        break;
      case D_pressDownRef.current:
        body.data = { y: flightSpeedRef.current, ...body.data, }
        break;
      case E_pressDownRef.current:
        body.data = { w: 15, ...body.data, }
        break;
      case Q_pressDownRef.current:
        body.data = { w: -15, ...body.data, }
        break;
      case UP_pressDownRef.current:
        body.data = { h: liftingSpeedRef.current, ...body.data, }
        break;
      case Down_pressDownRef.current:
        body.data = { h: -(liftingSpeedRef.current), ...body.data, }
        break;
      default:
        W_pressDownRef.current = false
        S_pressDownRef.current = false
        A_pressDownRef.current = false
        D_pressDownRef.current = false
        E_pressDownRef.current = false
        Q_pressDownRef.current = false
        UP_pressDownRef.current = false
        Down_pressDownRef.current = false
        body = false
        break;
    }
    setOperateMsg(opeFmMsg)
    setOperateOpacity({ ...ope })
    if (body) { publish(`thing/product/${sn}/drc/down`, JSON.stringify(body), 0, false) }
  };

  const handleKeyUp = (event) => {//监听 键盘弹起事件
    if (!mqttLinkRef.current) { return }
    hasKeyboardPerator.current = false
    let opeFmMsg = '无操作'
    let ope = operateOpacity

    switch (true) {
      case (event.key === 'w' || event.key === 'W')://前进
        W_pressDownRef.current = false
        ope.topOpacity = 0
        num = -1
        break;
      case (event.key === 's' || event.key === 'S')://后退
        S_pressDownRef.current = false
        ope.bottomOpacity = 0
        num = -1
        break;
      case (event.key === 'a' || event.key === 'A')://左移
        A_pressDownRef.current = false
        ope.leftOpacity = 0
        num = -1
        break;
      case (event.key === 'd' || event.key === 'D')://右移
        D_pressDownRef.current = false
        ope.rightOpacity = 0
        num = -1
        break;
      case (event.key === 'e' || event.key === 'E')://顺时针旋转
        E_pressDownRef.current = false
        ope.clockwiseOpacity = 0
        num = -1
        break;
      case (event.key === 'q' || event.key === 'Q')://逆时针旋转
        Q_pressDownRef.current = false
        ope.counterclockwiseOpacity = 0
        num = -1
        break;
      case event.key === 'ArrowUp'://Up
        UP_pressDownRef.current = false
        ope.upliftOpacity = 0
        num = -1
        break;
      case event.key === 'ArrowDown'://Down
        Down_pressDownRef.current = false
        ope.declineOpacity = 0
        num = -1
        break;

      default:
        break;
    }

    setOperateMsg(opeFmMsg)
    setOperateOpacity({ ...ope })

  };

  useEffect(() => {
    openOrCloseMqttInfo(true)
    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('keyup', handleKeyUp);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      window.removeEventListener('keyup', handleKeyUp);
      if (mqttLinkRef.current) {
        disconnect()
        clearInterval(mqttTimerRef.current)
        mqttTimerRef.current = null
        setMqttLink(false)
        openOrCloseMqttInfo(false)
        mqttLinkRef.current = false
      }
    }

    // eslint-disable-next-line
  }, [])



  return (
    <>{/* 无人机操作器 */}
      {
        mqttLinkRef.current &&
        <div className='pos_rel'>
          <Card>
            <>{/* 操作盘 */}
              <div className='pos_rel'>
                <img draggable='false' className='w232 h232' src={panel} alt='panel' />
                <>{/* 抬升 */}
                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(0deg)', zIndex: 1, }}
                  >
                    <div
                      className='pos_abs w103 h8'
                      style={{ top: '-84px', left: '-127px', transform: 'rotate(-45deg)', opacity: 1, }}
                    />
                  </div>

                  <div
                    className='pos_abs '
                    style={{ top: '50%', right: '50%', transform: 'rotate(0deg)' }}
                  >
                    <img draggable='false'
                      className='pos_abs'
                      style={{ top: '-117px', left: '-115px', opacity: operateOpacity.upliftOpacity, zIndex: 10 }}
                      src={uplift}
                      alt='uplift'
                      // 按下鼠标
                      onMouseDown={() => {
                        let ope = operateOpacity
                        num += 1
                        ope.upliftOpacity = 1
                        setOperateOpacity({ ...ope })
                        setOperateMsg('抬升')
                        let body = {
                          method: 'drone_control',
                          data: { h: liftingSpeedRef.current, }
                        }
                        mouseClickStart(body)
                      }}
                      // 松开鼠标
                      onMouseUp={() => {
                        let ope = { ...operateOpacity }
                        ope.upliftOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                      // 移出元素触发
                      onMouseOut={() => {
                        let ope = { ...operateOpacity }
                        ope.upliftOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                    />
                  </div>
                </>

                <>{/* 下降 */}
                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(0deg)', zIndex: 1, }}
                  >
                    <div
                      className='pos_abs w103 h8'
                      style={{ top: '73px', left: '-127px', transform: 'rotate(-135deg)', opacity: 1, }}
                    />
                  </div>

                  <div
                    className='pos_abs '
                    style={{ top: '50%', right: '50%', transform: 'rotate(0deg)' }}
                  >
                    <img draggable='false'
                      className='pos_abs'
                      style={{ top: '53px', left: '-115px', opacity: operateOpacity.declineOpacity, zIndex: 10 }}
                      src={decline}
                      alt='decline'
                      // 按下鼠标
                      onMouseDown={() => {
                        let ope = operateOpacity
                        ope.declineOpacity = 1
                        setOperateOpacity({ ...ope })
                        setOperateMsg('下降')
                        let body = {
                          method: 'drone_control',
                          data: { h: -liftingSpeedRef.current, }
                        }
                        mouseClickStart(body)
                      }}
                      // 松开鼠标
                      onMouseUp={() => {
                        let ope = { ...operateOpacity }
                        ope.declineOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                      // 移出元素触发
                      onMouseOut={() => {
                        let ope = { ...operateOpacity }
                        ope.declineOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                    />
                  </div>
                </>

                <>{/* 逆时针旋转 */}
                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(0deg)', zIndex: 1, }}
                  >
                    <div
                      className='pos_abs w103 h8'
                      style={{ top: '-88px', left: '23px', transform: 'rotate(-135deg)', opacity: 0, }}
                    />
                  </div>

                  <div
                    className='pos_abs '
                    style={{ top: '50%', right: '50%', transform: 'rotate(0deg)' }}
                  >
                    <img draggable='false'
                      className='pos_abs'
                      style={{ top: '-117px', left: '55px', opacity: operateOpacity.counterclockwiseOpacity, zIndex: 10 }}
                      src={counterclockwise}
                      alt='counterclockwise'
                      // 按下鼠标
                      onMouseDown={() => {
                        let ope = operateOpacity
                        ope.counterclockwiseOpacity = 1
                        setOperateOpacity({ ...ope })
                        setOperateMsg('逆时针旋转')
                        let body = {
                          method: 'drone_control',
                          data: { w: -15, }
                        }
                        mouseClickStart(body)
                      }}
                      // 松开鼠标
                      onMouseUp={() => {
                        let ope = { ...operateOpacity }
                        ope.counterclockwiseOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                      // 移出元素触发
                      onMouseOut={() => {
                        let ope = { ...operateOpacity }
                        ope.counterclockwiseOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                    />
                  </div>
                </>

                <>{/* 顺时针旋转 */}
                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(0deg)', zIndex: 1, }}
                  >
                    <div
                      className='pos_abs w103 h8'
                      style={{ top: '70px', left: '28px', transform: 'rotate(-45deg)', opacity: 0, }}
                    />
                  </div>

                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(0deg)' }}
                  >
                    <img draggable='false'
                      className='pos_abs'
                      style={{ top: '53px', left: '55px', opacity: operateOpacity.clockwiseOpacity, zIndex: 10 }}
                      src={clockwise}
                      alt='clockwise'
                      // 按下鼠标
                      onMouseDown={() => {
                        let ope = operateOpacity
                        ope.clockwiseOpacity = 1
                        setOperateOpacity({ ...ope })
                        setOperateMsg('顺时针旋转')
                        let body = {
                          method: 'drone_control',
                          data: { w: 15, }
                        }
                        mouseClickStart(body)
                      }}
                      // 松开鼠标
                      onMouseUp={() => {
                        let ope = { ...operateOpacity }
                        ope.clockwiseOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                      // 移出元素触发
                      onMouseOut={() => {
                        let ope = { ...operateOpacity }
                        ope.clockwiseOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                    />
                  </div>
                </>

                <>{/* ↑ */}
                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(-45deg)', zIndex: 1, }}
                  >
                    <div
                      className='pos_abs w103 h8'
                      style={{ top: '-4px', left: '0', opacity: 1, }}
                    />
                  </div>

                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(0deg)', zIndex: 1, }}
                  >
                    <img draggable='false'
                      className='pos_abs'
                      style={{ top: '-97px', left: '-65px', opacity: operateOpacity.topOpacity, zIndex: 10 }}
                      src={half}
                      alt='half'
                      // 按下鼠标
                      onMouseDown={() => {
                        let ope = operateOpacity
                        ope.topOpacity = 1
                        setOperateOpacity({ ...ope })
                        setOperateMsg('前进')
                        let body = {
                          method: 'drone_control',
                          data: { x: flightSpeedRef.current, }
                        }
                        mouseClickStart(body)

                      }}
                      // 松开鼠标
                      onMouseUp={() => {
                        let ope = operateOpacity
                        ope.topOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                      // 移出元素触发
                      onMouseOut={() => {
                        let ope = operateOpacity
                        ope.topOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                    />
                  </div>


                </>

                <>{/* → */}
                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(45deg)', zIndex: 1, }}
                  >
                    <div
                      className='pos_abs w103 h8'
                      style={{ top: '-4px', left: '0', opacity: 1, }}
                    />
                  </div>
                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(90deg)' }}
                  >
                    <img draggable='false'
                      className='pos_abs'
                      style={{ top: '-97px', left: '-65px', opacity: operateOpacity.rightOpacity, zIndex: 10 }}
                      src={half}
                      alt='half'
                      // 按下鼠标
                      onMouseDown={() => {
                        let ope = operateOpacity
                        ope.rightOpacity = 1
                        setOperateOpacity({ ...ope })
                        setOperateMsg('右移')
                        let body = {
                          method: 'drone_control',
                          data: { y: flightSpeedRef.current, }
                        }
                        mouseClickStart(body)
                      }}
                      // 松开鼠标
                      onMouseUp={() => {
                        let ope = operateOpacity
                        ope.rightOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                      // 移出元素触发
                      onMouseOut={() => {
                        let ope = operateOpacity
                        ope.rightOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                    />
                  </div>
                </>

                <>{/* ↓ */}
                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(135deg)', zIndex: 1, }}
                  >
                    <div
                      className='pos_abs w103 h8'
                      style={{ top: '-4px', left: '0px', opacity: 1, }}
                    />
                  </div>

                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(180deg)' }}
                  >
                    <img draggable='false'
                      className='pos_abs' style={{ top: '-97px', left: '-65px', opacity: operateOpacity.bottomOpacity, zIndex: 10 }}
                      src={half}
                      alt='half'
                      // 按下鼠标
                      onMouseDown={() => {
                        let ope = operateOpacity
                        ope.bottomOpacity = 1
                        setOperateOpacity({ ...ope })
                        setOperateMsg('后退')
                        let body = {
                          method: 'drone_control',
                          data: { x: -flightSpeedRef.current, }
                        }
                        mouseClickStart(body)
                      }}
                      // 松开鼠标
                      onMouseUp={() => {
                        let ope = operateOpacity
                        ope.bottomOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                      // 移出元素触发
                      onMouseOut={() => {
                        let ope = operateOpacity
                        ope.bottomOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                    />
                  </div>
                </>

                <>{/* ← */}
                  <div
                    className='pos_abs '
                    style={{ top: '50%', right: '50%', transform: 'rotate(225deg)', zIndex: 1, }}
                  >
                    <div
                      className='pos_abs w103 h8'
                      style={{ top: '-4px', left: '0', opacity: 1, }}
                    />
                  </div>

                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%', transform: 'rotate(270deg)' }}
                  >
                    <img draggable='false'
                      className='pos_abs'
                      style={{ top: '-97px', left: '-65px', opacity: operateOpacity.leftOpacity, zIndex: 10 }}
                      src={half}
                      alt='half'
                      // 按下鼠标
                      onMouseDown={() => {
                        let ope = operateOpacity
                        ope.leftOpacity = 1
                        setOperateOpacity({ ...ope })
                        setOperateMsg('左移')
                        let body = {
                          method: 'drone_control',
                          data: { y: -flightSpeedRef.current, }
                        }
                        mouseClickStart(body)
                      }}
                      // 松开鼠标
                      onMouseUp={() => {
                        let ope = { ...operateOpacity }
                        ope.leftOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                      // 移出元素触发
                      onMouseOut={() => {
                        let ope = { ...operateOpacity }
                        ope.leftOpacity = 0
                        setOperateOpacity({ ...ope })
                        mouseClickEnd()
                      }}
                    />
                  </div>
                </>

                <>{/* ⚪ */}
                  <div
                    className='pos_abs '
                    style={{ top: '50%', right: '50%', transform: 'rotate(225deg)', zIndex: 1, }}
                  >
                    <div
                      className='pos_abs w103 h8'
                      style={{ top: '-4px', left: '0', opacity: 1, }}
                    />
                  </div>

                  <div
                    className='pos_abs'
                    style={{ top: '50%', right: '50%' }}
                  >
                    <img draggable='false'
                      className='pos_abs'
                      style={{ top: '-44px', left: '-41px', zIndex: 10 }}
                      src={stop}
                      alt='stop'
                    // 按下鼠标
                    // onMouseDown={() => {
                    //   let ope = operateOpacity
                    //   ope.stop = 1
                    //   setOperateOpacity({ ...ope })
                    // }}
                    // // 松开鼠标
                    // onMouseUp={() => {
                    //   let ope = { ...operateOpacity }
                    //   ope.stop = 0
                    //   setOperateOpacity({ ...ope })
                    //   mouseClickEnd()
                    //   console.log('stop');
                    // }}
                    // // 移出元素触发
                    // onMouseOut={() => {
                    //   let ope = { ...operateOpacity }
                    //   ope.stop = 0
                    //   setOperateOpacity({ ...ope })
                    //   mouseClickEnd()
                    // }}
                    />
                  </div>
                </>
              </div>
            </>

            <>{/* 表单 */}
              <div className='marT16'>
                <Form className='w232'>
                  <Form.Item
                    style={{ margin: '0 0 8px 0', }}
                    label="飞行速度"
                  >
                    <InputNumber
                      addonAfter="m/s"
                      placeholder='-'
                      min={1}
                      max={17}
                      value={flightSpeedRef.current}
                      onChange={(e) => {
                        let ope = operateForm
                        ope.flightSpeed = e
                        flightSpeedRef.current = e
                        setOperateForm({ ...ope })
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    style={{ margin: '0 0 8px 0', }}
                    label="升降速度"
                  >
                    <InputNumber
                      addonAfter="m/s"
                      placeholder='-'
                      min={1}
                      max={4}
                      value={liftingSpeedRef.current}
                      onChange={(e) => {
                        let ope = operateForm
                        ope.liftingSpeed = e
                        liftingSpeedRef.current = e
                        setOperateForm({ ...ope })
                      }}
                    />
                  </Form.Item>
                </Form>
              </div>
            </>
          </Card>
        </div>
      }
    </>
  )
}
export default Operator;